import http from "../services/httpServices";
import React, { useContext, useEffect, useState, useRef } from "react";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { toast } from "react-toastify"; 
import cardService from "../services/cardServices";
import { Link } from 'react-router-dom';

import { MainContext } from "../store/mainContext";
export default function SelectDevice({ show, handleClose }) {
    const { defaultDevice, setDefaultDevice } = useContext(MainContext);
    useEffect(() => {
        getCard()
    }, []);

    const [list, setList] = useState([])

    const getCard = () => {
        const card = cardService.getCard();
        let choice = cardService.getChoiceCard();
        if (choice != []) {
            const article = card.find(m => choice != null && m.deviceNumber === choice.deviceNumber);
            if (article)
                article.ch = true;
        }
        setList(card);
        return card;
    }




    const deleteItem = (e, x) => {
        e.preventDefault();
        e.stopPropagation()
        cardService.deleteCard(x.id);
        const temp = getCard();
        if (defaultDevice != null && defaultDevice.id == x.id) {
            const temp2 = temp != [] ? temp[0] : null;
            cardService.saveChoiceCard(temp2);
            setDefaultDevice(temp2)
        }
    }

    const doChoice = (e, x) => {
        e.preventDefault();
        e.stopPropagation()
        cardService.saveChoiceCard(x);
        setDefaultDevice(x)
        handleClose(e, x)
    }
    return (
        <>
            <Offcanvas
                show={show}
                onHide={handleClose}
                placement="bottom"
                className="customBottomCanvas "  >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title className="w-100 d-flex justify-content-center">انتخاب خودرو</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {list.map((x, i) => (
                        <div className="row rounded border bg-secondary-subtle p-2 mb-3" key={"l" + i}>
                            <Link
                                className="col text-decoration-none text-dark"
                                onClick={(e) => { doChoice(e, x) }}>
                                {x.deviceName}
                            </Link>
                            <div className="col-auto">
                                {x.ch
                                    ? (<span className="text-success">✔ </span>)
                                    : <Link onClick={(e) => { deleteItem(e, x) }}>❌</Link>}
                            </div>
                        </div>
                    ))}
                </Offcanvas.Body>
            </Offcanvas>
        </>

    );

}
